import React, { Component, useEffect, useState } from 'react';
import { browserHistory } from 'react-router';
import api from '../../service/api';
import { CurrencyMask, CurrencyMaskForTable, FormatCurrencyForBackEnd } from '../../shared/helper/helperutil';
import TitlePage from '../../shared/components/html/title';
import ButtonsUpdate from '../../shared/components/buttons/update';
import  Input  from '../../shared/components/html/input';
import  InputNumber  from '../../shared/components/html/input-for-number';
import CustoIndireto from '../../models/CustoIndireto';
import ComponentForm from '../../shared/components/html/component-form';

 const AlterarCustoIndireto = (props:any) => {


    const [custo, setCusto] = useState<CustoIndireto>(new CustoIndireto(null));
    const [id] = useState<string>(props.location.query.id);
    const [msg, setMsg] = useState<string>('');

    useEffect(() => {
        if(id){
            getItem()
        }else{
            goTo()
        }
    },[])

    const getItem = async () => {
        try {
            const { data: repository } = await api.get(`/custo/indireto/${id}`)
            setCusto( new CustoIndireto(repository));
        } catch (err) {
            console.error(err)
        }
    }

    const altera = async event => {
        event.preventDefault();
        try {
            await api.put(`/custo/indireto/${id}`,
                {
                    "nome": custo.nome,
                    "descricao": custo.descricao,
                    "valor": FormatCurrencyForBackEnd(custo.valor)
                }
            )
            browserHistory.push('/consulta-custo-indireto?msg=atualizado')
        } catch (err) {
            setMsg('Houve um problema com o login, verifique seu usuário e senha!')

        }
    }

    const goTo = () => browserHistory.push('/consulta-custo-indireto');

    return (
        <>
            <TitlePage text={'Atualizar Custo Indireto'} />
            <ComponentForm submit={altera} method="put">
                <div className="row">
                    <Input 
                        class="col-md-6 mb-3"
                        id="nome-indireto"
                        placeholder="Nome do custo indireto"
                        value={custo.nome}
                        change={(e) => {custo.inputChange(e); setMsg(e.target.value)}}
                        label="Nome"
                        required={true}
                    />
                    <InputNumber
                        label="Preço custo indireto"
                        class="col-md-6 mb-3"
                        prefix={'R$'}
                        format={CurrencyMask}
                        value={custo.valor}
                        onChange={(e) => {custo.inputChange(e); setMsg(e.target.value)}}
                        id="valor-indireto"
                        placeholder="R$ 0,00"
                    />
                </div>
                <div className="row">
                    <Input 
                        class="col-md-12 mb-3"
                        id="descricao-indireto"
                        placeholder="Descrição do custo indireto"
                        value={custo.descricao}
                        change={(e) => {custo.inputChange(e); setMsg(e.target.value)}}
                        label="Descrição"
                        required={true}
                    />
                </div>
                <ButtonsUpdate url={'custo-indireto'} />
            </ComponentForm>
        </>
    );
}

export default React.memo(AlterarCustoIndireto); 